import React, { Component } from 'react'
import Style from './AdminManagement.module.css'
import { connect } from 'react-redux'
import { formatDetectionDatetime } from '../utilities/datetime'
import { withRouter } from 'react-router-dom';
import ConfirmPopup from './common/popover/confirmPopup'
import LoaderWrapper from './common/LoaderWrapper/LoaderWrapper';
import DashIcon from '../assets/minus.png'
import updateSvg from '../assets/update.svg'
import { getEnrolledEmailDomains, removeEnrolledEmailDomain, updateEnrolledEmailDomain, unSetStatusCode } from '../store/entities/customers'
class EnrolledEmailDomainManagement extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showRemoveConfirmationPopup: false,
            domainToRemove: null
        }
    }

    componentDidMount() {
        if(this.props.selectedCustomer) {
            this.props.getEnrolledEmailDomains(this.props.selectedCustomer.id)
        }    
    }

    componentDidUpdate(prevProps) {
        if(prevProps.addEnrolledEmailDomainFlag === true && this.props.addEnrolledEmailDomainFlag === false) {
            this.props.getEnrolledEmailDomains(this.props.selectedCustomer.id)
        }
        if(prevProps.removeEnrolledEmailDomainFlag === true && this.props.removeEnrolledEmailDomainFlag === false) {
            this.props.getEnrolledEmailDomains(this.props.selectedCustomer.id)
        }
        if(prevProps.updateEnrolledEmailDomainFlag === true && this.props.updateEnrolledEmailDomainFlag === false) {
            this.props.getEnrolledEmailDomains(this.props.selectedCustomer.id)
        }
    }

        handleRemoveDomain = (domainId, customerId) => {      
                this.setState({ showRemoveConfirmationPopup: true, domainToRemove: domainId })
        }

        handleConfirmRemoveDomain = () => {
            const { domainToRemove } = this.state
            if(domainToRemove && this.props.selectedCustomer) {
                this.props.removeEnrolledEmailDomain(this.props.selectedCustomer.id, domainToRemove)
            }
            this.setState({ showRemoveConfirmationPopup: false, domainToRemove: null })
        }

        clearStateValues = () => {
            this.setState({ showRemoveConfirmationPopup: false, domainToRemove: null })
            if(this.props.unSetStatusCode) this.props.unSetStatusCode()
        }

        handleEditDomain = (item) => {
                // navigate to the shared add/edit form with domain data
                if (this.props.selectedCustomer) {
                    this.props.history.push({
                        pathname: `/customers/${this.props.selectedCustomer.id}/settings/add-edit-email-domain`,
                        state: {
                            domain: item.domain || item.url || '',
                            domainId: item.domainId || item.id,
                            displayName: item.displayName || item.createdBy
                        }
                    })
                }
        }

    handleAddDomain = () => {
        this.props.history.push({pathname: `/customers/${this.props.selectedCustomer.id}/settings/add-edit-email-domain`}) 
    }

    render() {
        return (
            <div>
                <div className={'mt-4 w-100'}>
                    <div className={`${Style.titleStyle}`}>
                        Enrolled Email Domain Management
                    </div>
                    <div className={`${Style.shortInfoStyle} w-100 d-flex align-items-center mt-3 px-5`}>
                        <div style={{width: '80%'}} className={`${Style.borderStyle} px-4`}>
                            <div className={`${Style.fontBold}`}>
                                Current Enrolled Email Domains
                            </div>
                            <div className={`${Style.currentAdminCount}`}>
                            {this.props.enrolledDomains ? this.props.enrolledDomains.length : 0}
                            </div>
                        </div>
                        <div style={{width: '20%'}} className={'ml-4'}>
                            <div className={`${Style.fontBold}`}>
                            Add Enrolled Email Domain
                            </div>
                            <div className={'d-flex mt-3'}>
                                <button className={`${Style.submitButton} focus-none px-4`} onClick={this.handleAddDomain}>Add Enrolled Email Domain</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'mt-5'}>
                    <div className={Style.adminsStyle}>
                        Enrolled Email Domains
                    </div>
                    <div className={'mt-3'}>
                        <div className={`d-flex px-5 mx-2`}>
                            <div className={`${Style.fontBold}`} style={{width:'18%'}}><b>Name</b></div>
                            <div className={`${Style.fontBold}`} style={{width:'50%'}}><b>Domain</b></div>
                            <div className={`${Style.fontBold}`} style={{width:'32%'}}><b>Action</b></div>
                        </div>
                        <div className={`${Style.tableContainerStyle} p-4 mt-3`}>
                            <div className={`${Style.tableStyle} ${Style.ScrollStyle}`}>
                                {
                                    this.props.loading ?
                                        <LoaderWrapper loading={this.props.loading} isFlex={true} styles={{top: '50px'}} waitForData={false}></LoaderWrapper>
                                    :
                                    (this.props.enrolledDomains || []).map((item, index) => {
                                        return <div key={item.id || item.domainId || index} className={`${ index%2 === 0 ? Style.rowBg : Style.customRowBg} px-4 py-2`}>
                                            <div className={`d-flex p-2`}>
                                                <div className={`${Style.fontBold}`} style={{width:'18%'}}>
                                                    {item.displayName || item.createdBy || 'Pixm Admin'}
                                                </div>
                                                <div style={{width:'50%'}}>
                                                    <div>
                                                        {item.domain || item.url}
                                                    </div>
                                                    <div>
                                                        Created <i> {formatDetectionDatetime(item.creationTime || item.createdOn || item.creationDate)}</i>
                                                    </div>
                                                </div>
                                                <div className={`d-flex`} style={{width:'32%'}}>
                                                    {/* <div onClick={() => this.handleEditDomain(item)} className={`${Style.cursorStyle} ${Style.updateAdmin} d-flex mr-3`}>
                                                        <img
                                                            src={updateSvg}
                                                            style={{ height: '1.5vw' }}
                                                            alt="update-icon"
                                                        />
                                                        <div className={`${Style.removeAdmin} ml-1`}>Edit Domain</div>
                                                    </div> */}
                                                    <div onClick={() => this.handleRemoveDomain(item.domainId || item.id, this.props.selectedCustomer.id)} className={`${Style.cursorStyle} d-flex`}>
                                                        <div>
                                                            <img style={{height:'15px'}} src={DashIcon} alt="remove-icon"/>
                                                        </div>
                                                        <div className={`${Style.removeAdmin} ml-1`}>
                                                            Remove Domain
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            
                        </div>
                    </div>
                </div> 
                {this.state.showRemoveConfirmationPopup && (
                    <ConfirmPopup
                    details={{
                    icon: '',
                    type: 'info',
                    title: 'Do you want to remove this domain?',
                    description: "Note: Extension Users will not be able to register with this domain once it's removed.",
                    buttons: 'Y,C',
                    }}
                    onCancelClick={this.clearStateValues} 
                    onYesClick={this.handleConfirmRemoveDomain}
                    />
                )}
                {this.props.statusCode && (
                    <ConfirmPopup
                    details={{
                      icon: '',
                      type: this.props.statusCode === 200 ? 'success':'error',
                      title: this.props.statusCode === 200 ? 'Operation Successful':'Operation Failed',
                      description: this.props.userMsg,
                      buttons: 'O',
                      }}
                      onCloseClick={this.clearStateValues} />
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    userId: state.entities.user.id,
    tenantId: state.entities.user.tenantId,
    needRefreshToken: state.entities.customers.needRefreshToken,
    userMsg: state.entities.customers.userMsg,
    statusCode: state.entities.customers.statusCode,
    refreshToken: state.entities.user.refreshToken,
    loading: state.entities.customers.loading,
    enrolledDomains: state.entities.customers.enrolledEmailDomains,
    selectedCustomer: state.entities.customers.selected,
    addEnrolledEmailDomainFlag: state.entities.customers.addEnrolledEmailDomainFlag,
    removeEnrolledEmailDomainFlag: state.entities.customers.removeEnrolledEmailDomainFlag,
    updateEnrolledEmailDomainFlag: state.entities.customers.updateEnrolledEmailDomainFlag
})

const mapDispatchToProps = (dispatch) => ({
    getEnrolledEmailDomains: (customerId) => dispatch(getEnrolledEmailDomains(customerId)),
    removeEnrolledEmailDomain: (customerId, domainId) => dispatch(removeEnrolledEmailDomain(customerId, domainId)),
    updateEnrolledEmailDomain: (customerId, body) => dispatch(updateEnrolledEmailDomain(customerId, body)),
    unSetStatusCode: () => dispatch(unSetStatusCode())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnrolledEmailDomainManagement))